// This file is not yet translated.
/* eslint-disable i18next/no-literal-string */
import { Box, Button, OsModal, Typography } from "@outschool/backpack";
import { TrackedButton } from "@outschool/ui-components-shared";
import { Form, FormField, Input } from "@outschool/ui-legacy-component-library";
import React from "react";

type PasswordModalProps = {
  open: boolean;
  onClose: () => void;
  loading: boolean;
  switchViews: (password: string) => void;
  error?: string;
  title?: string;
};

const PasswordModal: React.FC<PasswordModalProps> = ({
  open,
  onClose,
  switchViews,
  loading,
  error,
  title = "Entering a protected space",
}) => {
  const [password, setPassword] = React.useState("");

  const handleSubmit = () => {
    switchViews(password);
  };

  return (
    <OsModal
      open={open}
      onClose={onClose}
      title={title}
      actionPrimary={
        <TrackedButton
          variant="contained"
          disabled={loading || !password}
          onClick={handleSubmit}
          trackingName="switch_views_with_password"
        >
          Switch spaces
        </TrackedButton>
      }
      actionSecondary={
        <Button variant="link" onClick={onClose}>
          Back
        </Button>
      }
    >
      <Box
        flex
        sx={{
          alignItems: "center",
          flexDirection: "column",
          padding: "1em",
        }}
      >
        <Typography
          variant="inherit"
          sx={{
            mb: "1em",
          }}
        >
          This space is password protected - to enter, type in the password for
          your Outschool account:
        </Typography>
        <Form
          sx={{ display: "grid", gap: "large", justifyItems: "center" }}
          onSubmit={e => {
            if (e) {
              e.preventDefault();
            }
            switchViews(password);
          }}
        >
          <FormField label="Outschool password" error={error}>
            <Input
              required
              type="password"
              value={password}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                setPassword(e.target.value)
              }
              sx={{ minWidth: 280 }}
              autoComplete="off"
            />
          </FormField>
        </Form>
      </Box>
    </OsModal>
  );
};

export default PasswordModal;
